import {
    READ_TOKENS_FROM_FORAGE,
    RESET_TOKENS,
    SET_TOKENS,
    // SET_ACCESSTOKEN,
    // SET_REFRESHTOKEN,
    REMOVE_TOKENS,
} from './constants'

export function setTokens(tokens) {
    return {
        type: READ_TOKENS_FROM_FORAGE,
        payload: tokens,
    }
}

export function resetTokens() {
    return { type: RESET_TOKENS }
}

export function setUserTokens(serverId, userId, tokens) {
    return {
        type: SET_TOKENS,
        payload: { serverId, userId, tokens },
    }
}

// export function setUserAccessToken(serverId, userId, accessToken) {
//     return {
//         type: SET_ACCESSTOKEN,
//         payload: { serverId, userId, accessToken },
//     }
// }

// export function setUserRefreshToken(serverId, userId, refreshToken) {
//     return {
//         type: SET_REFRESHTOKEN,
//         payload: { serverId, userId, refreshToken },
//     }
// }

export function removeUserTokens(serverId, userId) {
    return {
        type: REMOVE_TOKENS,
        payload: { serverId, userId },
    }
}



// WEBPACK FOOTER //
// ./src/features/Users/data/tokens/actions.js